module.exports = "<a [href]=\"\" (click)=\"loadStaticModules()\" class=\"btn btn-info btn-fill pe-7s-refresh-2\" download>\n  Load Modules\n</a>\n"